// German relative-time formatter for comment timestamps.
//
// Buckets: < 60 s → 'gerade eben', minutes, hours. Cross-day same year → 'dd.MM.',
// cross-year → 'dd.MM.yyyy'. Re-render once a minute while open is enough — at the
// minute/hour granularity, sub-second drift doesn't matter.

export function formatRelativeTime(iso: string, now: Date = new Date()): string {
  const then = new Date(iso);
  const deltaMs = now.getTime() - then.getTime();
  const sec = Math.floor(deltaMs / 1000);

  if (sec < 60) return 'gerade eben';

  const min = Math.floor(sec / 60);
  if (min < 60) return min === 1 ? 'vor 1 Minute' : `vor ${min} Minuten`;

  const hr = Math.floor(min / 60);
  if (hr < 24) return hr === 1 ? 'vor 1 Stunde' : `vor ${hr} Stunden`;

  // Cross-day. Same calendar year → date without year. Different year → full date.
  const sameYear = now.getFullYear() === then.getFullYear();
  return formatDate(then, sameYear);
}

function formatDate(d: Date, omitYear: boolean): string {
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return omitYear ? `${dd}.${mm}.` : `${dd}.${mm}.${yyyy}`;
}
